import React from "react"
import { cn, ELEMENTS, randoms } from "lib/utils"

export default function LayoutBuildBlock({ 
  label,
  type, 
  workingLayout,
  layoutBldrTools
}:{ 
  label:string; 
  type:string; 
  workingLayout:any
  layoutBldrTools:any
}){
  
  const { saveLayout }:any = layoutBldrTools 

  return (
    <div 
      onClick={() => type === "--" && saveLayout()}
      draggable={ type !== "--" && true }
      onDragStart={(e:any) => {
        e.dataTransfer.setData("type", type)
        e.dataTransfer.effectAllowed = "move"
      }}
      className={cn(
        "w-3/12 h-full flex justify-center items-center border border-solid border-neutral-100/50 text-xs uppercase tracking-widest text-white cursor-move",
        type === "--" && "bg-teal-800 cursor-pointer"
      )}
    >
      <span>{ label }</span>
    </div>
  )
}

